import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { EmptyListMessage } from 'components';
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'

@inject(rootStore => ({
    paperworkEntryStore: rootStore.paperworkEntryStore,
}))

@observer
class PaperworkEntryFilter extends React.Component {
    constructor(props) {
        super(props);
        this.onFilterChecboxChange = this.onFilterChecboxChange.bind(this);
    }

    onFilterChecboxChange(item) {
        this.props.paperworkEntryStore.setPaperworkStatusFilter(item.value);
        this.props.paperworkEntryStore.setPaperworkStatusSelectedValue(item);
        this.props.paperworkEntryStore.clear();
      }

    render() {
        const {
            paperworkStatusLookup,
            defaultStatusLookupSelectionValue
        } = this.props.paperworkEntryStore;
    
        if (!paperworkStatusLookup || paperworkStatusLookup.length === 0) {
            return <EmptyListMessage message={"Error while loading filter."} />
        }

        return (
            <div>   
                {
                    <div>
                    Status:
                    <Dropdown options={paperworkStatusLookup} value={defaultStatusLookupSelectionValue} onChange={this.onFilterChecboxChange}  placeholder="Select an option" />
                    </div>
                }
            </div>
        )
    }
}
export { PaperworkEntryFilter }


// WEBPACK FOOTER //
// ./src/modules/paperwork-entry/components/PaperworkEntryFilter.js